// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import App from './App'
// import chat from './components/shared/chat'
import base from './components/shared/base-template'
import router from './router'
import Vuetify from 'vuetify'
import { VueHammer } from 'vue2-hammer'
import 'vuetify/dist/vuetify.min.css'
import {
  extend,
  ValidationObserver,
  setInteractionMode,
  ValidationProvider,
  configure,
} from 'vee-validate'
import {
  required,
  email,
  min,
  max,
  length,
  regex,
} from 'vee-validate/dist/rules'
import VueResource from 'vue-resource'
import './stylus/main.styl'
import i18n from './i18n'
import VueMultianalytics from 'vue-multianalytics'
import GlobalEvents from 'vue-global-events'
import shared from './utils/shared'
// import validationMessages from 'vee-validate/dist/locale/en'
import Vuex from 'vuex'
import analyticsMixin from './multianalytics.js'
import VueGtm from 'vue-gtm'
import VueTheMask from 'vue-the-mask'
import { Vue2Storage } from 'vue2-storage'
import Bugsnag from './plugins/bugsnag.js'

// Refactor imports ----------------------
import store from './RF_store'

const moment = require('moment')
Vue.use(Vue2Storage)
Vue.use(VueTheMask)
Vue.use(require('vue-moment'), { moment })
Vue.use(VueHammer)

let sharedData = {
  customerId: '',
  accessToken: '',
  stateToken: '',
  phoneNumber: '',
  sourcePlatform: '',
  firstName: '',
  lastName: '',
  address: '',
  email: '',
  birthDateNotFormatted: '',
  adSource: '',
  startOnboarding: '',
  customerKey: '',
  leadExternalId: '',
  birthDate: '',
  line1: '',
  line2: '',
  city: '',
  password: '',
  state: '',
  postalCode: '',
  ssn: '',
  referralCode: '',
  pro: true,
  isAccountTypeFlow: true,
  incomeTypeFlow: false,
  isPlanActivelySelected: false,
  segment: '',
  incomeType: {
    title: '',
    id: '',
  },
}

let lastResponse = {}

sharedData.install = function () {
  Object.defineProperty(Vue.prototype, '$customerDetails', {
    get() {
      return sharedData
    },
    set(value) {
      sharedData = value
    },
  })
  Object.defineProperty(Vue.prototype, '$lastResponse', {
    get() {
      return lastResponse
    },
    set(value) {
      lastResponse = value
    },
  })
}

Vue.use(sharedData)

extend('name', {
  getMessage: () => '*Incorrect name',
  validate: (value) => shared.checkNameCharacters(value),
})

extend('passwordComplexity', {
  getMessage: () => '*Password is not complex enough',
  validate: (value) => shared.validatePasswordComplexity(value),
})

extend('email', email)
extend('min', min)
extend('max', max)
extend('length', length)
extend('regex', regex)
extend('required', required)
extend('date_format', {
  validate(value, args) {
    return moment(value, args[0]).isValid()
  },
  // message: 'Date must be in YYYY/MM/DD format',
  params: ['format'],
})

configure({
  // this will be used to generate messages.
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`fields.${field}`)
    // return i18n.t(`validations.messages.${values._rule_}`, values)
    return i18n.t(`validation.custom.${field}.${values._rule_}`, values)
  },
})

Vue.component('ValidationObserver', ValidationObserver)

Vue.component('ValidationProvider', ValidationProvider)
//   , {
//   events: 'blur',
//   i18n,
//   dictionary: {
//     en: validationMessages
//   }
// })

setInteractionMode('eager')

Vue.use(VueResource)

Vue.use(Vuetify, {
  theme: {
    light: true,
    themes: {
      light: {
        primary: '#701ef3',
        secondary: '#ff0095',
        accent: '#FF1744',
        error: '#f44336',
        warning: '#ffeb3b',
        info: '#2196f3',
        success: '#4caf50',
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
})

Vue.config.productionTip = false

Vue.component('LiliBase', base)
Vue.component('GlobalEvents', GlobalEvents)

// See https://github.com/Glovo/vue-multianalytics

Vue.use(
  VueMultianalytics,
  {
    routing: {
      vueRouter: router, //  Pass the router instance to automatically sync with router (optional)
      ignoredModules: ['ga', 'liliFacebook'], // Modules that will not send route change events. The event sent will be this.$ma.trackView({viewName: 'homepage'}, ['ga'])
    },
  },
  analyticsMixin
)

Vue.use(VueGtm, {
  id: 'GTM-PBHMZWW',
  vueRouter: router,
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
})

Vue.use(Vuex)

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason

  // Convert non-Error reasons to Error objects
  const error =
    reason instanceof Error
      ? reason
      : new Error(
          typeof reason === 'string' ? reason : 'Unhandled promise rejection'
        )

  // Report to Bugsnag with additional metadata if needed
  Bugsnag.notify(error, (event) => {
    event.addMetadata('promise', { rejectionReason: reason })
  })

  // Optional: Log to console for debugging
  // console.warn("Unhandled rejection:", reason);
})

let vueApp = new Vue({
  i18n,
  vuetify: new Vuetify(),
  el: '#app',
  store,
  router,
  components: {
    App,
  },
  template: '<App/>',
})

// https://docs.bugsnag.com/platforms/browsers/vue/
// bugsnagClient.use(bugsnagVue(Vue))

const mainModules = {
  vueApp,
  store,
}
export default mainModules



// WEBPACK FOOTER //
// ./src/main.js